// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.provably-fair-body .colorBlack {
  background: var(--primary-95) !important;
}
.provably-fair-body .columnBet,
.provably-fair-body .dozenBet,
.provably-fair-body .oddEvenBet,
.provably-fair-body .lowHighBet {
  background: var(--primary-95) !important;
}

.modal {
  background-color: var(--black-30);
  backdrop-filter: blur(2px);
}
.modal .input-modal-wrapper input {
  border: 1px solid var(--buttonBg) !important;
}
.modal input {
  border: 1px solid var(--WagerInput);
  background-color: var(--primary-95) !important;
  color: #fff;
}
.modal .input-group-text {
  background-color: var(--primary);
  border: 1px solid var(--buttonBg) !important;
  border-left: 0 !important;
}
.modal .input-group-text.input-copy-icon {
  background-color: var(--primary-95);
  border: 1px solid var(--buttonBg) !important;
  border-left: 0 !important;
}
.modal .copy-btn:hover {
  opacity: 0.7 !important;
  background: none;
}
.modal.plinkoModal .modal-content {
  max-width: 440px;
  margin: 0 auto;
}
.modal.plinkoModal .modal-content .heading {
  color: var(--white-100);
  text-align: center;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%;
}
.modal.plinkoModal .modal-content .modal-body {
  padding: 16px 24px 24px 24px;
}
.modal.plinkoModal .modal-content .multiply {
  margin-bottom: 16px !important;
}
.modal.plinkoModal .modal-content .detail-section {
  min-height: 77px;
  border-radius: var(--XS, 4px);
  background: var(--TabBgActive);
  padding: 12px 16px;
  align-items: center;
}
.modal.plinkoModal .modal-content .detail-section div.parent {
  align-items: center;
  width: 33.3333333333%;
}
.modal.plinkoModal .modal-content .detail-section div.parent:nth-child(2) {
  border-left: 1px solid var(--footerTopBorder);
  border-right: 1px solid var(--footerTopBorder);
  padding-left: 15px;
}
.modal.plinkoModal .modal-content .detail-section div.parent:nth-child(3) {
  padding-left: 15px;
}
.modal.plinkoModal .modal-content .detail-section p {
  color: var(--textColor);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  /* 21px */
}
.modal.plinkoModal .modal-content .multiply {
  border-radius: var(--XS, 4px);
  border: 1px solid var(--Mono-Secondary-025, rgba(239, 239, 239, 0.25));
}
.modal.plinkoModal .modal-content .multiply p {
  border-radius: 2px;
  box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.25);
  position: relative;
  padding: 0.2rem 1rem;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%;
  color: var(--white-100);
}
.modal.plinkoModal .modal-content .rowsSection {
  display: flex;
  padding: 12px 16px;
  justify-content: center;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
  border-radius: 4px;
  background: var(--primary);
  margin-bottom: 2rem;
}
.modal.plinkoModal .modal-content .play-plinko {
  border-radius: 8px;
  background: linear-gradient(180deg, #FF9F45 0%, #EF7403 100%);
  box-shadow: 0px 0px 10px 0px rgba(255, 159, 69, 0.4), 0px 1px 0px 0px rgba(239, 116, 3, 0.6) inset, 0px -3px 0px 0px rgba(255, 159, 69, 0.3) inset, 0px 0px 15px 0px #EF7403 inset;
  color: #FFF;
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%;
  border: 0;
  padding: 10px 10px;
  min-height: 41px;
}
.modal.plinkoModal .modal-content .provably-fair {
  display: flex;
  padding: 8px 24px;
  justify-content: center;
  align-items: flex-start;
  border-radius: 4px;
  border: 1px solid #1A9A8F;
  color: var(--white-100);
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%;
  background-color: transparent;
}
.modal.plinkoModal .modal-content .transactionBtn {
  margin-top: 9px;
  color: var(--white-100);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  /* 21px */
}
.modal.plinkoModal .modal-content .userIcon {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  margin: 0 8px;
}
.modal.plinkoModal .modal-content .placed-by {
  color: var(--textColor);
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
}
.modal.plinkoModal .modal-content .placed-by span {
  color: var(--white-100);
}
.modal .modal-dialog .modal-content {
  background-color: transparent;
  border: 1px solid transparent;
  border-radius: 0.937rem;
  max-width: 600px;
  margin: 0 auto;
  border-radius: 8px;
}
.modal .modal-dialog .modal-content .modal-body {
  position: relative;
  background: var(--primary);
  border-radius: 16px;
}
.modal .modal-dialog .modal-content .modal-body .btn-close-modal {
  position: absolute;
  top: 1rem;
  right: 1rem;
  border: 0;
}
.modal .modal-dialog .btn-start-playing {
  border-radius: 8px;
  background: linear-gradient(180deg, #FF9F45 0%, #EF7403 100%);
  box-shadow: 0px 0px 10px 0px rgba(255, 159, 69, 0.4), 0px 1px 0px 0px rgba(239, 116, 3, 0.6) inset, 0px -3px 0px 0px rgba(255, 159, 69, 0.3) inset, 0px 0px 15px 0px #EF7403 inset;
  color: #FFF;
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%;
  border: 0;
  padding: 10px 10px;
  min-height: 41px;
}
.modal .modal-dialog .btn-start-playing:hover {
  border-radius: 8px;
  background: linear-gradient(180deg, #FF9F45 0%, #EF7403 100%);
  box-shadow: 0px 0px 10px 0px rgba(255, 159, 69, 0.4), 0px 1px 0px 0px rgba(239, 116, 3, 0.6) inset, 0px -3px 0px 0px rgba(255, 159, 69, 0.3) inset, 0px 0px 15px 0px #EF7403 inset;
  color: #FFF;
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%;
  border: 0;
  padding: 10px 10px;
  min-height: 41px;
}
.modal.vessel-modal-bg .modal-dialog {
  max-width: 900px;
}
.modal.vessel-modal-bg .modal-dialog .modal-content {
  background-repeat: no-repeat;
  background-size: 100% auto;
  background-position: center bottom;
}
.modal .btn-sidebar-modal {
  color: var(--white);
}

.historySection .historyHeading {
  padding: 12px 1rem;
}
.historySection .historyHeading p {
  color: var(--Mono-Secondary-05, rgba(239, 239, 239, 0.5));
  font-size: 14px;
  font-weight: 400;
  margin: 0;
}
.historySection .historyDetail ul li {
  padding: 1rem;
  border-radius: 5px;
}
.historySection .historyDetail ul li span {
  color: var(--white-100);
  font-size: 14px;
  font-weight: 500;
}
.historySection .historyDetail ul li:nth-child(odd) {
  background: var(--primary-95);
}

.pagination-buttons {
  display: flex;
  gap: 1.5rem;
  justify-content: center;
  margin-top: 2rem;
}
.pagination-buttons button {
  color: var(--white-100);
  font-size: 14px;
  font-weight: 400;
  border: 0;
  background-color: transparent;
}
.pagination-buttons button:disabled {
  color: #383E4D;
}

.dice-modal-lg .modal-content {
  background-color: var(--primary-95);
}`, "",{"version":3,"sources":["webpack://./src/components/ui-kit/Popup/Popup.scss"],"names":[],"mappings":"AAgBE;EACE,wCAAA;AAfJ;AAkBE;;;;EAIE,wCAAA;AAhBJ;;AAoBA;EACE,iCAAA;EACA,0BAAA;AAjBF;AAoBI;EACE,4CAAA;AAlBN;AAsBE;EACE,mCAAA;EACA,8CAAA;EACA,WAAA;AApBJ;AAuBE;EACE,gCAAA;EACA,4CAAA;EACA,yBAAA;AArBJ;AAsBI;EACE,mCAAA;EACA,4CAAA;EACA,yBAAA;AApBN;AAwBE;EACE,uBAAA;EACA,gBAAA;AAtBJ;AA0BI;EACE,gBAAA;EACA,cAAA;AAxBN;AA0BM;EACE,uBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAxBR;AA2BM;EACE,4BAAA;AAzBR;AA4BM;EACE,8BAAA;AA1BR;AA6BM;EACE,gBAAA;EACA,6BAAA;EACA,8BAAA;EACA,kBAAA;EACA,mBAAA;AA3BR;AA6BQ;EACE,mBAAA;EACA,qBAAA;AA3BV;AA6BU;EACE,6CAAA;EACA,8CAAA;EACA,kBAAA;AA3BZ;AA8BU;EACE,kBAAA;AA5BZ;AAgCQ;EACE,uBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,SAAA;AA9BV;AAkCM;EACE,6BAAA;EACA,sEAAA;AAhCR;AAkCQ;EACE,kBAAA;EACA,+CAAA;EACA,kBAAA;EACA,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;AAhCV;AAoCM;EACE,aAAA;EACA,kBAAA;EACA,uBAAA;EACA,uBAAA;EACA,SAAA;EACA,mBAAA;EACA,kBAAA;EACA,0BAAA;EACA,mBAAA;AAlCR;AAqCM;EA9IJ,kBAAA;EACA,6DAAA;EACA,kLAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,SAAA;EACA,kBAAA;EACA,gBAAA;AA4GF;AA2BM;EACE,aAAA;EACA,iBAAA;EACA,uBAAA;EACA,uBAAA;EACA,kBAAA;EACA,yBAAA;EACA,uBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,6BAAA;AAzBR;AA4BM;EACE,eAAA;EACA,uBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,SAAA;AA1BR;AA6BM;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;AA3BR;AA8BM;EACE,uBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AA5BR;AA8BQ;EACE,uBAAA;AA5BV;AAmCI;EACE,6BAAA;EACA,6BAAA;EACA,uBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AAjCN;AAmCM;EACE,kBAAA;EACA,0BAAA;EACA,mBAAA;AAjCR;AAmCQ;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,SAAA;AAjCV;AAsCI;EAzNF,kBAAA;EACA,6DAAA;EACA,kLAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,SAAA;EACA,kBAAA;EACA,gBAAA;AAsLF;AA0BM;EA3NJ,kBAAA;EACA,6DAAA;EACA,kLAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,SAAA;EACA,kBAAA;EACA,gBAAA;AAoMF;AAmBI;EACE,gBAAA;AAjBN;AAmBM;EAEE,4BAAA;EACA,0BAAA;EACA,kCAAA;AAlBR;AAuBE;EACE,mBAAA;AArBJ;;AA0BE;EACE,kBAAA;AAvBJ;AAyBI;EACE,yDAAA;EACA,eAAA;EACA,gBAAA;EACA,SAAA;AAvBN;AA6BM;EACE,aAAA;EACA,kBAAA;AA3BR;AA6BQ;EACE,uBAAA;EACA,eAAA;EACA,gBAAA;AA3BV;AA8BQ;EACE,6BAAA;AA5BV;;AAoCA;EACE,aAAA;EACA,WAAA;EACA,uBAAA;EACA,gBAAA;AAjCF;AAmCE;EACE,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,SAAA;EACA,6BAAA;AAjCJ;AAmCI;EACE,cAAA;AAjCN;;AAuCE;EACE,mCAAA;AApCJ","sourcesContent":["@mixin BetButton {\n  border-radius: 8px;\n  background: linear-gradient(180deg, #FF9F45 0%, #EF7403 100%);\n  box-shadow: 0px 0px 10px 0px rgba(255, 159, 69, 0.40), 0px 1px 0px 0px rgba(239, 116, 3, 0.60) inset, 0px -3px 0px 0px rgba(255, 159, 69, 0.30) inset, 0px 0px 15px 0px #EF7403 inset;\n  color: #FFF;\n  text-align: center;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 150%;\n  border: 0;\n  padding: 10px 10px;\n  min-height: 41px;\n}\n\n.provably-fair-body {\n  .colorBlack {\n    background: var(--primary-95) !important;\n  }\n\n  .columnBet,\n  .dozenBet,\n  .oddEvenBet,\n  .lowHighBet {\n    background: var(--primary-95) !important;\n  }\n}\n\n.modal {\n  background-color: var(--black-30);\n  backdrop-filter: blur(2px);\n\n  .input-modal-wrapper {\n    input {\n      border: 1px solid var(--buttonBg) !important;\n    }\n  }\n\n  input {\n    border: 1px solid var(--WagerInput);\n    background-color: var(--primary-95) !important;\n    color: #fff;\n  }\n\n  .input-group-text {\n    background-color: var(--primary);\n    border: 1px solid var(--buttonBg) !important;\n    border-left: 0 !important;\n    &.input-copy-icon {\n      background-color: var(--primary-95);\n      border: 1px solid var(--buttonBg) !important;\n      border-left: 0 !important;\n    }\n  }\n\n  .copy-btn:hover {\n    opacity: 0.7 !important;\n    background: none;\n  }\n\n  &.plinkoModal {\n    .modal-content {\n      max-width: 440px;\n      margin: 0 auto;\n\n      .heading {\n        color: var(--white-100);\n        text-align: center;\n        font-size: 20px;\n        font-style: normal;\n        font-weight: 600;\n        line-height: 150%;\n      }\n\n      .modal-body {\n        padding: 16px 24px 24px 24px;\n      }\n\n      .multiply {\n        margin-bottom: 16px !important;\n      }\n\n      .detail-section {\n        min-height: 77px;\n        border-radius: var(--XS, 4px);\n        background: var(--TabBgActive);\n        padding: 12px 16px;\n        align-items: center;\n\n        div.parent {\n          align-items: center;\n          width: calc(100% / 3);\n\n          &:nth-child(2) {\n            border-left: 1px solid var(--footerTopBorder);\n            border-right: 1px solid var(--footerTopBorder);\n            padding-left: 15px;\n          }\n\n          &:nth-child(3) {\n            padding-left: 15px;\n          }\n        }\n\n        p {\n          color: var(--textColor);\n          font-size: 14px;\n          font-style: normal;\n          font-weight: 400;\n          line-height: 150%;\n          /* 21px */\n        }\n      }\n\n      .multiply {\n        border-radius: var(--XS, 4px);\n        border: 1px solid var(--Mono-Secondary-025, rgba(239, 239, 239, 0.25));\n\n        p {\n          border-radius: 2px;\n          box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.25);\n          position: relative;\n          padding: 0.2rem 1rem;\n          font-size: 14px;\n          font-style: normal;\n          font-weight: 500;\n          line-height: 150%;\n          color: var(--white-100);\n        }\n      }\n\n      .rowsSection {\n        display: flex;\n        padding: 12px 16px;\n        justify-content: center;\n        align-items: flex-start;\n        gap: 16px;\n        align-self: stretch;\n        border-radius: 4px;\n        background: var(--primary);\n        margin-bottom: 2rem;\n      }\n\n      .play-plinko {\n        @include BetButton();\n      }\n\n      .provably-fair {\n        display: flex;\n        padding: 8px 24px;\n        justify-content: center;\n        align-items: flex-start;\n        border-radius: 4px;\n        border: 1px solid #1A9A8F;\n        color: var(--white-100);\n        text-align: center;\n        font-size: 14px;\n        font-style: normal;\n        font-weight: 500;\n        line-height: 150%;\n        background-color: transparent;\n      }\n\n      .transactionBtn {\n        margin-top: 9px;\n        color: var(--white-100);\n        font-size: 14px;\n        font-style: normal;\n        font-weight: 400;\n        line-height: 150%;\n        /* 21px */\n      }\n\n      .userIcon {\n        width: 20px;\n        height: 20px;\n        border-radius: 50%;\n        margin: 0 8px;\n      }\n\n      .placed-by {\n        color: var(--textColor);\n        text-align: center;\n        font-size: 14px;\n        font-style: normal;\n        font-weight: 400;\n        line-height: 150%;\n\n        span {\n          color: var(--white-100);\n        }\n      }\n    }\n  }\n\n  .modal-dialog {\n    .modal-content {\n      background-color: transparent;\n      border: 1px solid transparent;\n      border-radius: 0.937rem;\n      max-width: 600px;\n      margin: 0 auto;\n      border-radius: 8px;\n\n      .modal-body {\n        position: relative;\n        background: var(--primary);\n        border-radius: 16px;\n\n        .btn-close-modal {\n          position: absolute;\n          top: 1rem;\n          right: 1rem;\n          border: 0;\n        }\n      }\n    }\n\n    .btn-start-playing {\n      @include BetButton();\n      &:hover {\n        @include BetButton();\n      }\n    }\n  }\n\n  &.vessel-modal-bg {\n    .modal-dialog {\n      max-width: 900px;\n\n      .modal-content {\n        // background-image: url('../../../../public/assets/images/common/vessel-modal-bg.png');\n        background-repeat: no-repeat;\n        background-size: 100% auto;\n        background-position: center bottom;\n      }\n    }\n  }\n\n  .btn-sidebar-modal {\n    color: var(--white);\n  }\n}\n\n.historySection {\n  .historyHeading {\n    padding: 12px 1rem;\n\n    p {\n      color: var(--Mono-Secondary-05, rgba(239, 239, 239, 0.50));\n      font-size: 14px;\n      font-weight: 400;\n      margin: 0;\n    }\n  }\n\n  .historyDetail {\n    ul {\n      li {\n        padding: 1rem;\n        border-radius: 5px;\n\n        span {\n          color: var(--white-100);\n          font-size: 14px;\n          font-weight: 500;\n        }\n\n        &:nth-child(odd) {\n          background: var(--primary-95);\n        }\n      }\n\n    }\n  }\n}\n\n.pagination-buttons {\n  display: flex;\n  gap: 1.5rem;\n  justify-content: center;\n  margin-top: 2rem;\n\n  button {\n    color: var(--white-100);\n    font-size: 14px;\n    font-weight: 400;\n    border: 0;\n    background-color: transparent;\n\n    &:disabled {\n      color: #383E4D;\n    }\n  }\n}\n\n.dice-modal-lg {\n  .modal-content {\n    background-color: var(--primary-95)\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
